import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store/hooks';

import { COURSE_STRUCTURES, COURSE_TYPES } from 'constants/common';

import { updateCourseById, updateDailyChallengeById } from 'store/course/actions';
import { currentCourseSelector } from 'store/course/selectors';

export const useCheckCourseStructure = () => {
  const dispatch = useAppDispatch();

  const course = useSelector(currentCourseSelector);

  useEffect(() => {
    if (course && course.structure) {
      const clearStructure = () => {
        if (course.type === COURSE_TYPES.DAILY_CHALLENGE) {
          dispatch(
            updateDailyChallengeById({
              courseId: course.id,
              data: { structure: null },
            }),
          );

          return;
        }

        dispatch(
          updateCourseById({
            courseId: course.id,
            data: { structure: null },
          }),
        );
      };

      if (
        course.structure === COURSE_STRUCTURES.MODULES &&
        course.modules &&
        course.modules.length === 0
      ) {
        clearStructure();

        return;
      }

      if (
        course.structure === COURSE_STRUCTURES.LESSONS &&
        course.lessons &&
        course.lessons.length === 0
      ) {
        clearStructure();

        return;
      }
    }
  }, [course]);
};
